export const createLatestRequestController = () => {
  let generation = 0;
  let currentKey = "";
  let abortController = null;

  const isCurrent = request =>
    !!request &&
    request.generation === generation &&
    request.key === currentKey &&
    !request.signal.aborted;

  const begin = key => {
    const nextKey = String(key || "");

    if (!nextKey || nextKey === currentKey) {
      return null;
    }

    generation += 1;
    abortController?.abort();
    abortController = new AbortController();
    currentKey = nextKey;

    return {
      generation,
      key: nextKey,
      signal: abortController.signal,
    };
  };

  const clear = () => {
    generation += 1;
    abortController?.abort();
    abortController = null;
    currentKey = "";
  };

  const complete = request => {
    if (isCurrent(request)) {
      abortController = null;
    }
  };

  const fail = request => {
    if (isCurrent(request)) {
      abortController = null;
      currentKey = "";
    }
  };

  return {
    begin,
    clear,
    complete,
    fail,
    isCurrent,
  };
};
